import React, { SVGAttributes } from "react";

import * as S from "./TherapeuticAreaIcon.style";
import { BackgroundType } from "./types/therapeuticAreaType.types";
import { THERAPEUTIC_AREA_CATEGORY_ICONS } from "../../constants/therapeuticAreaIconGroup.constants";
import { IconTADefault } from "../../Icons";
import AvatarBackground from "../core/AvatarBackground/AvatarBackground";

interface Props extends SVGAttributes<SVGAElement> {
  therapeuticArea: string;
  backgroundType: BackgroundType;
  backgroundColor?: string;
  width?: number;
  height?: number;
  iconColor?: string;
}

const TherapeuticAreaIcon = ({
  therapeuticArea,
  backgroundType = "default",
  backgroundColor,
  width = 24,
  height = 24,
  iconColor = "#2A2F37",
  ...rest
}: Props) => {
  if (therapeuticArea === "") {
    return null;
  }

  const therapeuticAreaString =
    typeof therapeuticArea === "string" && therapeuticArea !== ""
      ? therapeuticArea.toLowerCase()
      : "";

  if (therapeuticAreaString === "") {
    return null;
  }

  const CurrentIcon =
    THERAPEUTIC_AREA_CATEGORY_ICONS[
      therapeuticAreaString as keyof typeof THERAPEUTIC_AREA_CATEGORY_ICONS
    ] || IconTADefault;

  if (backgroundType === "transparent") {
    return (
      <CurrentIcon width={width} height={height} color={iconColor} {...rest} />
    );
  }

  return (
    <S.ModalityIconWrapper>
      <S.IconBackground
        $backgroundType={backgroundType}
        $backgroundColor={backgroundColor}
      >
        <AvatarBackground
          containerSize={`${width / 10}rem`}
          className="modality-icon-background"
        >
          <CurrentIcon
            width={width}
            height={height}
            color={iconColor}
            {...rest}
          />
        </AvatarBackground>
      </S.IconBackground>
    </S.ModalityIconWrapper>
  );
};

export default TherapeuticAreaIcon;
